import {GroupCelebration, Poll, Recognition} from "@irati/types"
import {GROUP_CELEBRATION, POLL, RECOGNITION} from "@irati/recognition/constants/feedTypes"
import {RecognitionRoutes} from "../enums/Routes"

const getRewardRecognitionLink = (recognition: Recognition) => {
  if (!recognition?.uuid) {
    return null
  }
  if (window.location.pathname.includes(RecognitionRoutes.ACCOUNT)) {
    return `${RecognitionRoutes.MY_ACCOUNT_RECOGNITIONS}/${RECOGNITION}/${recognition.uuid}/reward/?type=add_reward`
  }
  return `${RecognitionRoutes.POLLS}/${RECOGNITION}/${recognition.uuid}/reward/?type=add_reward`
}
const getRecognitionPath = (recognition: Recognition) => {
  if (!recognition?.uuid) {
    return null
  }
  if (window.location.pathname.includes(RecognitionRoutes.ACCOUNT)) {
    return `${RecognitionRoutes.MY_ACCOUNT_RECOGNITIONS}/${RECOGNITION}/${recognition.uuid}`
  }

  return `${RecognitionRoutes.POLLS}/${RECOGNITION}/${recognition.uuid}`
}
const getPollPath = (poll: Poll) => {
  if (!poll?.uuid) {
    return null
  }
  if (window.location.pathname.includes(RecognitionRoutes.MY_ACCOUNT_CLOSED_POLLS)) {
    return `${RecognitionRoutes.MY_ACCOUNT_CLOSED_POLLS}/${poll.uuid}`
  }
  if (window.location.pathname.includes(RecognitionRoutes.MY_ACCOUNT_VOTES)) {
    return `${RecognitionRoutes.MY_ACCOUNT_VOTES}/${POLL}/${poll.uuid}`
  }
  return `${RecognitionRoutes.POLLS}/${POLL}/${poll.uuid}`
}
const getPollPublishPath = (poll: Poll) => {
  if (!poll?.uuid) {
    return null
  }
  return `${RecognitionRoutes.MY_ACCOUNT_CLOSED_POLLS}/${poll.uuid}/publish`
}
const getGroupCelebrationPath = (groupCelebration: GroupCelebration) => {
  if (window.location.pathname.includes(RecognitionRoutes.POLLS)) {
    return `${RecognitionRoutes.POLLS}/${GROUP_CELEBRATION}/${groupCelebration.uuid}`
  }
  if (window.location.pathname.includes(RecognitionRoutes.MY_ACCOUNT_RECOGNITIONS)) {
    return `${RecognitionRoutes.MY_ACCOUNT_RECOGNITIONS}/${GROUP_CELEBRATION}/${groupCelebration.uuid}`
  }
  return `${RecognitionRoutes.MY_ACCOUNT_GROUP_CELEBRATIONS}/${groupCelebration.uuid}`
}
export {getRecognitionPath, getPollPath, getGroupCelebrationPath, getRewardRecognitionLink, getPollPublishPath}
